export enum LicenseStatusEnum {
  Active = 'ACTIVE',
  Trialing = 'TRIALING',
  Suspended = 'SUSPENDED',
  Cancelled = 'CANCELLED'
}